const ja = {
  nav_dashboard: 'ダッシュボード', nav_inventory: '在庫', nav_my_stock: 'マイストック',
  nav_containers: 'コンテナ', nav_requests: 'リクエスト', nav_invoices: '請求書',
  nav_payments: '支払い', nav_settings: '設定', nav_sign_out: 'ログアウト',
  nav_customers: '顧客', nav_employees: 'スタッフ', nav_tasks: 'タスク',
  nav_scan: 'スキャン', nav_pricing: '価格設定', nav_price_quotes: '見積もり',
  nav_selection_orders: '選択注文',
  btn_save: '保存', btn_cancel: 'キャンセル', btn_delete: '削除', btn_edit: '編集',
  btn_add: '追加', btn_submit: '送信', btn_approve: '承認', btn_reject: '拒否',
  btn_download: 'ダウンロード', btn_upload: 'アップロード', btn_search: '検索',
  btn_confirm: '確認', btn_close: '閉じる', btn_view: '表示', btn_remove: '削除',
  btn_back: '戻る', btn_sign_in: 'ログイン', btn_save_changes: '変更を保存',
  login_title: 'BIG STAR', login_subtitle: '中古車・部品輸出管理',
  login_username: 'ユーザー名', login_email: 'メール', login_password: 'パスワード',
  login_remember: '記憶する', login_invalid: '認証情報が無効です',
  detail_make: 'メーカー', detail_model: 'モデル', detail_year: '年式',
  detail_chassis: 'シャーシ番号', detail_color: '色', detail_mileage: '走行距離',
  detail_grade: 'グレード', detail_score: 'スコア', detail_engine_code: 'エンジンコード',
  detail_transmission: 'トランスミッション', detail_condition: '状態', detail_status: 'ステータス',
  detail_price: '価格', detail_fob: 'FOB価格', detail_steering: 'ステアリング',
  detail_drive: '駆動方式', detail_displacement: '排気量',
  status_available: '在庫あり', status_assigned: '割当済', status_sold: '売約済',
  status_shipped: '出荷済', status_in_transit: '輸送中', status_delivered: '納品済',
  status_japan_yard: 'ヤード内', status_loading: '積込中', status_pending: '保留中',
  status_approved: '承認済', status_rejected: '却下',
  vehicles: '車両', engines: 'エンジン', parts: 'パーツ', dashboard: 'ダッシュボード',
  add: '追加', edit: '編集', save: '保存', cancel: 'キャンセル', delete: '削除',
  search: '検索', noData: 'データなし', totalUnits: '合計ユニット', printQR: 'QR印刷',
  dash_welcome: 'ようこそ、{name}',
  dash_total_fob: 'FOB合計額',
  dash_late_night: '深夜', dash_hello: 'こんにちは',
  dash_subtitle: '車両、部品、入荷予定の概要をリアルタイムで確認できます。',
  dash_local_time: '現地時間', dash_status: 'ステータス', dash_all_systems_live: '全システム稼働中',
  dash_view_recommendations: 'おすすめを見る', dash_my_stock: 'マイストック', dash_in_transit: '輸送中',
  dash_units: '台', dash_containers: 'コンテナ', dash_browse_more: 'もっと見る',
  dash_track_shipments: '出荷を追跡', dash_browse_inventory_start: '在庫を閲覧して始めましょう',
  dash_no_active_shipments: '出荷中の貨物はありません', dash_next_eta: '次の到着予定', dash_days: '日',
  dash_etas_confirming: '到着日を確認中', dash_this_week: '今週',
  dash_arriving_soon: 'まもなく到着', dash_logistics: 'ロジスティクス', dash_active_shipments: '出荷中',
  dash_view_all: 'すべて表示', dash_shipment_empty: 'ユニットがコンテナに積載されると、次の出荷がここに表示されます',
  dash_composition: '構成', dash_stock_breakdown: '在庫内訳', dash_no_units_yet: 'ユニットはまだありません',
  dash_browse_to_build: '在庫を閲覧してストックを構築しましょう',
  dash_for_you: 'おすすめ', dash_picked_based: 'お客様の在庫に基づいて選定', dash_browse_all: 'すべて閲覧',
  dash_picking_units: 'ユニットを選定中です。後ほどご確認いただくか、全在庫をご覧ください',
  dash_view_details: '詳細を見る', dash_just_arrived: '新着', dash_similar: '類似車両',
  dash_today: '今日', dash_tomorrow: '明日',
};
export default ja;
